import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import ReactDOM from "react-dom";
import axios from "../../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import ImageZoom from "react-medium-image-zoom";

const tipe_soal = [
    { key: "single", value: "Single Option" },

    { key: "essay", value: "Essay" }
];


class Lists extends React.Component {
    constructor() {
        super();
        this.state = {
            dataSoal: [],
            detailSoal: [],
            dataQuestion: [],
            dataDetailExam: {},
            jumlahPilihanGanda: 0,
            exam_cat_id: 0,
            pageCount: 0,
            currentPage: 0,
            isLoading: false,
            isDetailExamLoading: false,
            isModalShow: false,
            isModalEditShow: false,
            question_id:"",
            score:0,
            question_type : "",
            linkExport:""
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name] : value,
        })

    }

    loadData() {
        this.setState({ isLoading: true });

        axios({
            method: "post",
            url: '/ujian/soal/list',
            data: qs.stringify({question_type:this.state.question_type, exam_id: this.props.match.params.exam_id, user_id: localStorage.SISMART_USER_ID, page: this.state.currentPage + 1 })
        })
            .then(response => {
                const result = response.data;
                
                if (result.success === true) {

                    this.setState({
                        dataQuestion: result.data.soal,
                        pageCount: result.data.soal.last_page,
                        dataDetailExam: result.data.exam,
                        isLoading: false
                    });
                    var jumlah_soal = 0
                    // for(var i=0; i< result.data.soal.length; i++){
                    //     jumlah_soal = jumlah_soal+ result.data.soal[i].question.length
                    // }
                    this.setState({
                        jumlah_soal: result.data.soal.length
                    })


                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadFile() {
        this.setState({ isLoading: true });

        axios({
            method: "post",
            url: '/ujian/soal/export',
            data: qs.stringify({question_type:this.state.question_type, exam_id: this.props.match.params.exam_id, user_id: localStorage.SISMART_USER_ID, page: this.state.currentPage + 1 })
        })
            .then(response => {
                const result = response.data;
                if (result.success === true) {

                    this.setState({
                        linkExport: result.data.link[0].link,
                        isLoading: false
                    });

                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataDetail(e) {

        this.setState({ isLoading: true });
        axios({
            method: "post",
            url: '/ujian/soal/detail',
            data: qs.stringify({ question_id: e, exam_id: this.props.match.params.exam_id})
        })

            .then(response => {
                const result = response.data;
                if (result.success) {
                    this.setState({
                        detailSoal: result.data,
                        score: result.data.score,
                        question_id: result.data.question_id,
                        isLoading: false
                    });

                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }

            })

            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    componentDidMount() {
        this.loadData();
        this.loadFile();
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevState.question_type !== this.state.question_type ) {
            this.loadData()
        }

    }


    render() {
        return (
            <div>
                <div>
                    <div className="card">
                        <div className="card-header">
                            Preview
                        </div>
                        <div className="card-body">
                            <div className="col col-md-12" style={{ paddingTop:'50px',paddingBottom:'50px',display:'table',textAlign:'center' }}>
                                {this.state.isLoading ? (
                                    <div className="loader" style={{
                                        borderLeft: '15px solid #20a8d8'
                                    }}></div>
                                ) : this.state.linkExport ? (
                                    <a
                                        href={this.state.linkExport}
                                        target="_blank"
                                        className="btn btn-danger"
                                        style={{ verticalAlign: 'bottom', width:'150px', color:'#fff' }}
                                    >
                                        <i className="fa fa-download"></i>{" "}Download Soal
                                    </a>
                                ) : (
                                    <div className="loader" style={{
                                        borderLeft: '15px solid #20a8d8'
                                    }}></div>
                                )
                                }

                            </div>
                        </div>
                    </div>
                    <div className="card">
                    <div className="card-body">
                        <table className="table table-striped table-bordered animated fadeIn">
                            <tr>
                                <td width={150}>Judul </td>
                                <td>{this.state.dataDetailExam.exam_title}</td>
                            </tr>
                            <tr>
                                <td>Deskripsi </td>
                                <td>{this.state.dataDetailExam.exam_desc}</td>
                            </tr>
                            <tr>
                                <td>Tanggal Mulai </td>
                                <td>{this.state.dataDetailExam.exam_start_date}</td>
                            </tr>
                            <tr>
                                <td>Tanggal Selesai </td>
                                <td>{this.state.dataDetailExam.exam_end_date}</td>
                            </tr>
                            <tr>
                                <td>Durasi </td>
                                <td>{this.state.dataDetailExam.exam_time_limit}</td>
                            </tr>
                            <tr>
                                <td>Soal </td>
                                <td>{this.state.jumlah_soal}</td>
                            </tr>
                        </table>
                    </div>
                    <div className="card">
                        {this.state.isLoading ? (
                            "Memuat Data..."
                        ) : this.state.dataQuestion.length === 0 ? (
                            "Data Kosong..."
                        ) : (
                            <div>
                                <div className="card-block">
                                    <div>
                                        <table className="table table-striped table-bordered animated fadeIn">
                                            <thead>
                                            <tr>
                                                <th width={25}>No</th>
                                                <th>Pertanyaan</th>
                                                {/*<th width={25}>Order</th>*/}
                                                {/* <th width={200}>Opsi</th> */}
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                this.state.dataQuestion.map((itemQues, i) => {
                                                    return (
                                                        <tr key={itemQues.question_id}>
                                                            <td>{i + 1}</td>
                                                            <td>
                                                                <span className="badge badge-danger">{itemQues.question_type}</span><br />
                                                                <p><div dangerouslySetInnerHTML={{__html: itemQues.question_text}}/></p>
                                                                {
                                                                    itemQues.question_pict ? (
                                                                        <div>
                                                                            <ImageZoom
                                                                                image={{
                                                                                    src: "data:" + itemQues.question_type_pict + ";base64," + itemQues.question_pict,
                                                                                    className: 'img',
                                                                                    style: {width: '20em'}
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    ) : ""
                                                                }

                                                                <p style={{marginBottom: 5}}/>
                                                                {itemQues.question_type == 'essay' ? (
                                                                    "Essay..."
                                                                ) : (
                                                                    itemQues.question_type == 'match' ? (
                                                                        itemQues.opsi.length > '0' ? itemQues.opsi.map((itemx, i) => (
                                                                                <div
                                                                                    className="checkbox"
                                                                                    key={`pilihanGanda-${itemx.question_id}-${i}`}
                                                                                >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        value="option1"
                                                                                        checked={itemx.score.length > 0}
                                                                                        style={{marginRight: 5}}
                                                                                        disabled
                                                                                    />
                                                                                    {itemx.option_text + " "}
                                                                                    <i className="fa fa-arrows-h fa-lg mt-4"></i>
                                                                                    {" " + itemx.option_match_text}
                                                                                </div>
                                                                            )) :
                                                                            <div
                                                                                className="alert alert-danger"
                                                                                role="alert">
                                                                                No Option!! Question Not valid
                                                                            </div>
                                                                    ) : (
                                                                        itemQues.opsi.length > '0' ? itemQues.opsi.map((itemx, i) => (
                                                                                <div className="radio"
                                                                                     key={`pilihanGanda-${itemx.question_id}-${i}`}>
                                                                                    <input
                                                                                        type="radio"
                                                                                        value="option1"
                                                                                        checked={itemx.score.length > 0}
                                                                                        style={{marginRight: 5}}
                                                                                        disabled
                                                                                    />
                                                                                    <a>{itemx.option_text}</a>

                                                                                    {
                                                                                        itemx.option_pict ? (
                                                                                            <ImageZoom
                                                                                                image={{
                                                                                                    src: "data:" + itemx.type_pict + ";base64," + itemx.option_pict,
                                                                                                    className: 'img',
                                                                                                    style: {width: '10em'}
                                                                                                }}
                                                                                            />
                                                                                        ) : (
                                                                                            <ImageZoom
                                                                                                image={{
                                                                                                    src: "./noimage.gif",
                                                                                                    className: 'img',
                                                                                                    style: {width: '5em'}
                                                                                                }}
                                                                                            />
                                                                                        )
                                                                                    }
                                                                                </div>
                                                                            )) :
                                                                            <div
                                                                                className="alert alert-danger"
                                                                                role="alert">
                                                                                No Option!! Question Not valid
                                                                            </div>
                                                                    )
                                                                )
                                                                }
                                                            </td>
                                                            {/*<td>{itemQues.ehq_order ? <span className="badge badge-danger">{itemQues.ehq_order}</span> :  <span className="badge badge-danger">0</span> }</td>*/}
                                                            
                                                        </tr>
                                                    );
                                                })
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {/*<Paging*/}
                                {/*    handlePageClick={this.handlePageClick.bind(this)}*/}
                                {/*    pageCount={this.state.pageCount}*/}
                                {/*    currentPage={this.state.currentPage}*/}
                                {/*/>*/}
                            </div>
                        )}
                    </div>

                </div>
                </div>
            </div>
        );
    }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Exam/Schedule/Export.js